import React from "react";
import { Tabs, Tab } from "@mui/material";
import {
  AssistantRounded,
  MediationRounded,
  AssistantOutlined,
  MediationOutlined,
} from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  customTabs: {
    minHeight: 36,
    marginTop: 2,
    "& .MuiTabs-indicator": {
      height: 4,
      borderRadius: "50px 50px 0px 0px",
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.primary.main : "#9C27B0",
    },
    "& .MuiTab-root": {
      minHeight: 36,
      paddingTop: 6,
      paddingBottom: 6,
    },
    "& .MuiTabs-flexContainer": {
      minHeight: 36,
      paddingTop: 6,
      paddingBottom: 4,
    },
    "& .MuiTab-root.Mui-selected": {
      color:
        theme.palette.mode === "dark" ? theme.palette.primary.main : "#9C27B0",
    },
  },
}));

function MessageTabs({ message, selectedTab, handleClickTab }) {
  const { classes } = useStyles();
  const { answer } = message;
  // Get citations count for the Sources tab badge (count unique files, not individual citations)
  const citations = answer["content_object"]["citations"] || [];
  const uniqueFileIds = [
    ...new Set(citations.map((citation) => citation.file_id)),
  ];
  const sourcesCount = uniqueFileIds.length;

  const isAnswerFound = answer["content_object"]["answer_found"];
  return (
    <Tabs
      value={selectedTab}
      onChange={(_, value) => {
        handleClickTab(value);
      }}
      className={classes.customTabs}>
      <Tab
        label="AI Answer"
        value={"ai_answer"}
        iconPosition="start"
        icon={
          selectedTab === "ai_answer" ? (
            <AssistantRounded fontSize="small" />
          ) : (
            <AssistantOutlined fontSize="small" />
          )
        }
      />
      {isAnswerFound && (
        <Tab
          label={`Sources (${sourcesCount})`}
          value={"sources"}
          iconPosition="start"
          icon={
            selectedTab === "sources" ? (
              <MediationRounded fontSize="small" />
            ) : (
              <MediationOutlined fontSize="small" />
            )
          }
        />
      )}
    </Tabs>
  );
}

export default MessageTabs;
